<template>
  <div
    style="background-color: white;
          position: fixed;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
      "
  >
    <div class="py-2" style="text-align: center;">
      <span class="icon">
        <img style="height: 84px;width: 84px;" src="../assets/logo.svg" />
      </span>
    </div>
    <span class="mr-3">Loading</span>
    <span>
      <pulse-loader :loading="true" :color="'#0A4EA2'" :size="'5px'"></pulse-loader>
    </span>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  components: {
    PulseLoader,
  },
};
</script>

<style lang="scss" >
.v-spinner {
  display: inline-block;
}
</style>